import { mergeWorkoutLayers } from './merge-workout-layers';
export const mergeAthleteWorkoutLayers = (baseLayer, athleteLayer, ...rest) => {
    let mergedWorkout;
    if (baseLayer) {
        mergedWorkout = mergeWorkoutLayers(baseLayer, athleteLayer, ...rest);
    }
    else if (athleteLayer) {
        mergedWorkout = mergeWorkoutLayers(athleteLayer, ...rest);
    }
    return mergedWorkout;
};
/**
 * Utility function to merge workout layers by passing in just WorkoutLayer objects.
 * This wrapper constructs the required HasWorkoutLayer objects internally.
 */
export function mergeAthleteWorkoutFromLayers(workoutId, baseLayer, athleteLayer, ...rest) {
    const baseHasLayer = baseLayer
        ? {
            layer: baseLayer,
            workoutId,
            id: '',
        }
        : undefined;
    const athleteHasLayer = athleteLayer
        ? {
            layer: athleteLayer,
            workoutId,
            id: '',
        }
        : undefined;
    const restHasLayers = rest.map(layer => layer
        ? {
            layer,
            workoutId,
            id: '',
        }
        : undefined);
    return mergeAthleteWorkoutLayers(baseHasLayer, athleteHasLayer, ...restHasLayers);
}
//# sourceMappingURL=merge-athlete-workout.js.map